import {
  signIn,
  signUp,
  confirmSignUp,
  signOut,
  getCurrentUser,
  fetchAuthSession,
  resetPassword,
  confirmResetPassword,
  resendSignUpCode
} from 'aws-amplify/auth'

const state = {
  user: null,
  isLoggedIn: false,
  session: null,
  tokens: null
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    state.isLoggedIn = !!user
  },
  SET_SESSION(state, session) {
    state.session = session
    state.tokens = session?.tokens || null

  },
  CLEAR_AUTH(state) {
    state.user = null
    state.isLoggedIn = false
    state.session = null
    state.tokens = null
  }
}

const actions = {
  async signIn({ dispatch }, { username, password }) {
    const result = await signIn({ username, password })

    if (result.isSignedIn) {
      await dispatch('fetchSession')
    }

    return result
  },

  async signUp(_, { username, password, email }) {
    const result = await signUp({
      username,
      password,
      attributes: {
        email
      }
    })
    return result
  },

  async confirmSignUp(_, { username, code }) {
    const result = await confirmSignUp({ username, confirmationCode: code })
    return result
  },

  async signOut({ commit }) {
    try {
      await signOut()
      commit('CLEAR_AUTH')
    } catch (error) {
      commit('CLEAR_AUTH') // Clear local state even if sign out fails
      throw error
    }
  },

  async fetchSession({ commit }) {
    try {
      const [user, session] = await Promise.all([
        getCurrentUser(),
        fetchAuthSession()
      ])

      commit('SET_USER', user)

      commit('SET_SESSION', session)

      return { user, session }
    } catch (error) {
      // User not logged in
      commit('CLEAR_AUTH')
      throw error
    }
  },

  async resetPassword(_, { username }) {
    return resetPassword({ username })
  },

  async confirmResetPassword(_, { username, code, newPassword }) {
    const result = await confirmResetPassword({
      username,
      confirmationCode: code,
      newPassword
    })
    return result
  },

  async resendSignUpCode(_, { username }) {
    const result = await resendSignUpCode({ username })
    return result
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  user: state => state.user,
  session: state => state.session,
  tokens: state => state.tokens,
  accessToken: state => state.tokens?.accessToken?.toString(),
  idToken: state => state.tokens?.idToken?.toString(),
  refreshToken: state => state.tokens?.refreshToken?.toString()
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
